import { createClient } from '@supabase/supabase-js';

const PLACEHOLDER_URL = 'https://placeholder.supabase.co';
const PLACEHOLDER_ANON = 'placeholder-anon-key';

const rawUrl = import.meta.env.VITE_SUPABASE_URL;
const rawAnon = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(rawUrl && rawAnon);

if (!isSupabaseConfigured && typeof window !== 'undefined') {
  console.warn(
    '[sun-calendar] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY not set at build time. ' +
      'The UI will render but calls to the backend will fail. Set them as GitHub Actions secrets and redeploy.',
  );
}

const url = rawUrl || PLACEHOLDER_URL;
const anon = rawAnon || PLACEHOLDER_ANON;

export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
});

export const FUNCTIONS_URL = `${url}/functions/v1`;
